module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/star_hover_CM.234e6a35.svg";